






















import { computed, defineComponent, Ref } from '@vue/composition-api';
import Page from '@/pages/Page.vue';
import Event from '@/components/structural/Event.vue';
import store from '@/store';
import { groupBy, keys } from 'lodash';
import {
  parseJSON, parse, format, isValid,
} from 'date-fns';
import { pl } from 'date-fns/locale';

const EventListPage: object = defineComponent({
  name: 'EventListPage',
  components: {
    Page,
    Event,
  },
  filters: {
    dateFormat(date: string): string {
      return format(
        parse(date, 'yyyy-MM-dd', new Date()),
        'd MMMM yyyy',
        { locale: pl },
      );
    },
  },
  setup() {
    const groupedEvents: Ref<any> = computed(
      () => groupBy(
        store.state.events.features,
        (o :any) => {
          let date: Date = parseJSON(o.properties.startTime);

          if (!isValid(date)) {
            date = parseJSON(o.properties.createTime);
          }
          return format(date, 'yyyy-MM-dd');
        },
      ),
    );

    const orderedDays: Ref<any> = computed(
      () => keys(groupedEvents.value).sort().reverse(),
    );

    return {
      groupedEvents,
      orderedDays,
    };
  },
});
export default EventListPage;
